import dynamic from 'next/dynamic'
import Form from '@bluheadless/ui-logic/src/components/form/form'
import { useFormFields } from '@bluheadless/ui-logic/src/hooks/form/useFormFields'
import { useNotification } from '@bluheadless/ui-logic/src/hooks/useNotification'
import { useUserActions } from '@bluheadless/ui-logic/src/providers/user/user-actions'
import { yupResolver } from '@hookform/resolvers/yup'
import { object } from 'prop-types'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { object as yupObject } from 'yup'
import SubmitButton from '../../../../molecules/button/submit-button'
import { ControlledInput } from '../../../../molecules/input/input'
import ForgottenLink from '../forgotten-password/forgotten-link'

const ForgottenDialog = dynamic(() => import('../forgotten-password/forgotten-dialog'), { ssr: false })

const LoginForm = ({ formProps, forgottenLinkProps, source, redirect, redirectTo }) => {
	const { enqueueNotification } = useNotification()
	const { login } = useUserActions()
	const [showDialog, setShowDialog] = useState(false)

	const toggleForgottenDialog = (show) => {
		setShowDialog(show)
	}

	const { formatMessage } = useIntl()

	const handleSubmit = async (formFields) => {
		try {
			await login({ ...formFields, redirect, redirectTo, source })
			enqueueNotification({ uiProps: { message: formatMessage({ id: 'login_submit_success' }) } })
		} catch (error) {
			enqueueNotification({
				uiProps: {
					severity: 'error',
					message: error?.response?.data?.error?.message ?? error.message ?? formatMessage({ id: 'an_error_occurred' }),
				},
			})
		}
	}
	const { email, password } = useFormFields()

	const schemaDefault = yupObject(
		{
			[email.name]: email.validation,
			[password.name]: password.validation,
		},
		[]
	)

	return (
		<>
			<Form
				noValidate
				options={{
					resolver: yupResolver(schemaDefault),
				}}
				onSubmit={handleSubmit}
				{...formProps}
			>
				<ControlledInput name={email.name} id="email" label={email.label} required autoComplete="email" />
				<ControlledInput
					name={password.name}
					id="password"
					label={password.label}
					type="password"
					required
					autoComplete="current-password"
				/>
				<ForgottenLink toggleForgottenDialog={toggleForgottenDialog} {...forgottenLinkProps} />
				<SubmitButton fullWidth label={formatMessage({ id: 'login_submit' })} />
			</Form>
			<ForgottenDialog open={showDialog} toggleForgottenDialog={toggleForgottenDialog} />
		</>
	)
}

LoginForm.propTypes = {
	formProps: object,
	forgottenLinkProps: object,
}

export default LoginForm
